import { CountdownTypesEnum } from 'common/components/entities/Countdown/enums/CountdownTypesEnum'
import { CountdownInterface } from 'common/types/entities/CountdownInterface'
import { getCounterEndTimeCookie } from 'common/utils/countdownCookie'

const getEndTime = ({
  deadlineTime,
  postfix,
  pageId,
  entity,
}: {
  entity: CountdownInterface
  pageId: number
  postfix: number | null
  deadlineTime: number | null
}) => {
  switch (entity.countdownType) {
    case CountdownTypesEnum.daily:
    case CountdownTypesEnum.delay: {
      const cookieValue = getCounterEndTimeCookie(pageId, postfix)
      const cookieTime = cookieValue
        ? Number.parseInt(String(cookieValue), 10)
        : NaN
      // it may be null if not found
      if (Number.isInteger(cookieTime)) {
        return cookieTime
      }
      return null
    }
    case CountdownTypesEnum.deadline: {
      return deadlineTime
    }
    case CountdownTypesEnum.fixed: {
      return new Date(entity[CountdownTypesEnum.fixed].date).getTime()
    }
  }
}

export const wasCompletedForCurrentUser = ({
  entity,
  postfix,
  pageId,
  deadlineTime,
}: {
  entity: CountdownInterface
  pageId: number
  postfix: number | null
  deadlineTime: number | null
}) => {
  const endTime = getEndTime({ deadlineTime, postfix, pageId, entity })

  return endTime ? endTime < Date.now() : false
}
